const isStringEmpty = (str: string): boolean => {
  if (str.length == 0) return true;
  else return false;
};
export default isStringEmpty;
